<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }}<em v-if="data1['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
        <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7">{{ `${data7['druidParamName']}` }}<em v-if="data7['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write"
               :class="{'title-write-red' : true}">视点
          </div>
          <span class="title-more fr" @click="toTwoPage('/methanol/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/methanol/industry', item.id, 2)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li>
          <ClassificationHeader :name="'价格'" :flag="true" :unit="false" :url="'/methanol/twoPage/price'"
                                :params="{title:'价格'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in priceOneList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/methanol/price', item.completeOriginalDate)">
                {{ item.date + '甲醇价格' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'开工率'" :flag="true" :unit="false" :url="'/methanol/twoPage/rate'"
                                :params="{title:'开工率'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in rateList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/methanol/rate', item.completeOriginalDate)">{{ item.date + '甲醇开工率' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/methanol/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/methanol/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/methanol/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/methanol/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'产量'" :flag="true" :unit="false" :url="'/methanol/twoPage/yield'"
                                :params="{title:'产量'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/methanol/yield', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '甲醇全国周产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'库存'" :flag="true" :unit="false" :url="'/methanol/twoPage/stock'"
                                :params="{title:'库存'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in stockList" :key="index"
                 @click="goDetail('/methanol/stock', item.completeOriginalDate, 'issue_steel_thread_stock')">
              <i></i>
              <p>{{ item.date + '甲醇库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/methanol/map')" alt="">
<!--                        <Expect :marginTop="'40px'"></Expect>-->
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'进出口量'" :flag="true" :unit="false"
                                :url="'/methanol/twoPage/exit'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in exitOneList" :key="index"
                 @click="goDetail('/methanol/exit', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '甲醇进出口量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游产品价格'" :flag="true" :unit="false" :url="'/methanol/twoPage/productPrice'"
                                :params="{title:'下游产品价格'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in productPriceList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/methanol/productPrice', item.completeOriginalDate)">
                {{ item.date + '甲醇下游产品价格' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <span
              style="position: absolute;top:20px;left:20px;width: 72px;height: 33px;font-size: 24px;font-weight: 500;color: #FFFFFF;line-height: 33px;">需求量</span>
          <img src="../../assets/methanol/chanliang.png" alt="">
          <em @click="toTwoPage('/methanol/twoPage/demand')"
              style="position: absolute;right:15px;top:25px;color:#fff;font-style:normal;cursor: pointer"> >> </em>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in demandList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/methanol/demand', item.completeOriginalDate)">
                {{ item.date + '甲醇需求量' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/methanol/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 7px;">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="industrialFlag">
      <MethanolIndustrial :chainPrice="chainPrice" :chainTitle="chainTitle" :data1="data1" :data2="data2" :data3="data3"
                          :data4="data4" :data5="data5" :data6="data6" :data7="data7"
                          @closeIndustrialCh="closeIndustrial"
                          v-if="industrialFlag"></MethanolIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  industryDetail,
  methanolPriceNoAuthList,
  rateNoAuthList,
  noAuthReportAndStandard,
  methanolYieldNoAuthList,
  stockNoAuthList,
  exitNoAuthList,
  methanolReportDetail,
  standardDetail,
  productPriceNoAuthList,
  demandNoAuthList,
  chainList
} from '@/api/methanol'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import MethanolIndustrial from '@/components/bigChart/methanolIndustrial'

export default {
  components: {
    ClassificationHeader,
    MethanolIndustrial,
    Expect,
  },
  data() {
    return {
      industryFlag: 2,
      industrialFlag: false,
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceOneList: [],
      // 下游产品价格
      productPriceList: [],
      // 库存
      stockList: [],
      // 开工率
      rateList: [],
      // 进出口量
      exitOneList: [],
      // 产量
      yieldList: [],
      // 行业标准
      standardList: [],
      // 需求量
      demandList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      chainPrice: {},
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_methanol_chain_price'}).then(res => {
        this.chainTitle = res.data['data1']['date']
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 15}).then(res => {
        this.industryList = res.rows;
      })
      // 价格指数
      methanolPriceNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_methanol_price', dataType: 1}).then(res => {
        this.priceOneList = res.rows;
      })
      // 开工率
      rateNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_methanol_rate', dataType: 2}).then(res => {
        this.rateList = res.rows;
      })
      // 研究报告
      noAuthReportAndStandard({pageNum: 1, pageSize: 6, sourceType: 8, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      noAuthReportAndStandard({pageNum: 1, pageSize: 6, sourceType: 8, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      noAuthReportAndStandard({pageNum: 1, pageSize: 6, sourceType: 8, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 产量
      methanolYieldNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_methanol_yield', dataType: 2}).then(res => {
        this.yieldList = res.rows;
      })
      // 库存
      stockNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_methanol_stock_area', dataType: 2}).then(res => {
        this.stockList = res.rows
      })
      // 进出口量
      exitNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_methanol_exit', dataType: 3}).then(res => {
        this.exitOneList = res.rows;
      })
      // 下游产品价格
      productPriceNoAuthList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: 'issue_methanol_product_price',
        dataType: 1
      }).then(res => {
        this.productPriceList = res.rows;
      })
      // 需求量
      demandNoAuthList({pageNum: 1, pageSize: 7}).then(res => {
        this.demandList = res.rows;
      })
      // 技术及标准
      noAuthReportAndStandard({pageNum: 1, pageSize: 8, sourceType: 8, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      methanolReportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['甲醇', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['甲醇', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag) {
      this.$router.push({path: `${url}`, query: {id, flag}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/methanol/banner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #B2F0E4;
      top: 31px;
      left: 248px;
      font-size: 12px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 174px;
      left: 29px;
      width: 96px;
      height: 70px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 172px;
      left: 217px;
      width: 95px;
      height: 50px;
    }

    .data3 {
      font-size: 10px;
      position: absolute;
      top: 47px;
      right: 12px;
      width: 240px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 117px;
      right: 12px;
      width: 240px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 186px;
      right: 12px;
      width: 240px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 252px;
      right: 12px;
      width: 240px;
      height: 50px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 321px;
      right: 12px;
      width: 240px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 175px;
      left: 147px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 35px;
      right: 286px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 97px;
      right: 286px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 168px;
      right: 286px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 230px;
      right: 285px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      position: absolute;
      top: 295px;
      right: 286px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;
      position: relative;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 124px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
